<template>
  <div class="xk-img-code" style="width: 100%;height: 100%">
    <canvas id="canvas-img-code" width="100" height="50"></canvas>
  </div>
</template>

<script>
  export default {
    name: 'xk-img-code',
    props: {
      code: { // 传进来的  验证码
        default () {
          return null
        }
      }
    },
    data () {
      return {}
    },
    watch: {
      code (val) {
        if (val) {
          this.clickChange(val)
        }
      }
    },
    methods: {
      getColorFn () { // 生成颜色码
        // 定义字符串变量colorValue存放可以构成十六进制颜色值的值
        let colorValue = '0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f'
        // 以","为分隔符，将colorValue字符串分割为字符数组["0","1",...,"f"]
        let colorArray = colorValue.split(',')
        let color = '#'// 定义一个存放十六进制颜色值的字符串变量，先将#存放进去
        // 使用for循环语句生成剩余的六位十六进制值
        for (let i = 0; i < 6; i++) {
          // colorArray[Math.floor(Math.random()*16)]随机取出
          // 由16个元素组成的colorArray的某一个值，然后将其加在color中，
          // 字符串相加后，得出的仍是字符串
          color += colorArray[Math.floor(Math.random() * 16)]
        }
        return color
      },
      lineXFn () { // 计算 干扰线 X坐标
        return Math.floor(Math.random() * 90)
      },
      lineYFn () { // 计算 干扰线 Y坐标
        return Math.floor(Math.random() * 40)
      },
      clickChange (code) { // 生成
        if (!code) {
          return
        }
        let mycanvas = document.getElementById('canvas-img-code')
        let cxt = mycanvas.getContext('2d')
        cxt.fillStyle = this.getColorFn()
        cxt.fillRect(0, 0, 90, 40)

        /* 生成干扰线20条 */
        for (let j = 0; j < (Math.random() * 100); j++) {
          cxt.strokeStyle = this.getColorFn()
          cxt.beginPath()    // 若省略beginPath，则每点击一次验证码会累积干扰线的条数
          cxt.moveTo(this.lineXFn(), this.lineYFn())
          cxt.lineTo(this.lineXFn(), this.lineYFn())
          cxt.lineWidth = 0.5
          cxt.closePath()
          cxt.stroke()
        }

        cxt.fillStyle = this.getColorFn()
        cxt.font = 'bold 20px Arial'
        cxt.fillText(code, 18, 25)   // 把rand()生成的随机数文本填充到canvas中
      }
    },
    mounted: function () {
      this.clickChange()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .xk-img-code {
  }
</style>



// WEBPACK FOOTER //
// imgCode.vue?15e6da32